import React, { useState, useEffect } from "react";
import "../styles/SalesForm.css";

const parseShorthandNumber = (value) => {
  if (typeof value === "string") {
    const lowerValue = value.toLowerCase();
    if (lowerValue.endsWith("k")) {
      return parseFloat(lowerValue.replace("k", "")) * 1000;
    }
    if (lowerValue.endsWith("m")) {
      return parseFloat(lowerValue.replace("m", "")) * 1000000;
    }
  }
  return parseFloat(value);
};

const SalesForm = ({ gaugeId, onSubmit, onClose, formData, isUpdateMode }) => {
  const [formState, setFormState] = useState({
    title: "",
    number: "",
    tickMarks: "",
    rangeFrom: "",
    rangeTo: "",
    interval: "",
  });

  useEffect(() => {
    if (formData) {
      setFormState(formData);
    }
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { title, number, tickMarks, rangeFrom, rangeTo, interval } = formState;

    if (!title || !number || !tickMarks || !rangeFrom || !rangeTo || !interval) {
      alert("Please fill out all fields");
      return;
    }

    const parsedRangeFrom = parseShorthandNumber(rangeFrom);
    const parsedRangeTo = parseShorthandNumber(rangeTo);
    const parsedInterval = parseShorthandNumber(interval);

    if (isNaN(parsedRangeFrom) || isNaN(parsedRangeTo) || isNaN(parsedInterval)) {
      alert("Please enter valid numeric values for Range From, Range To, and Interval.");
      return;
    }

    onSubmit({
      gaugeId,
      title,
      number,
      tickMarks: parseInt(tickMarks, 10),
      rangeFrom: parsedRangeFrom,
      rangeTo: parsedRangeTo,
      interval: parsedInterval,
    });

    onClose();
  };

  return (
    <div className="popup">
      <div className="popup-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h2>{isUpdateMode ? "Update this Gauge" : "Create New Gauge"}</h2>
        <form onSubmit={handleSubmit}>
          <label>Title:</label>
          <input
            type="text"
            name="title"
            value={formState.title}
            onChange={handleChange}
            placeholder="Enter title"
            required
          />

          <label>Number:</label>
          <input
            type="text"
            name="number"
            value={formState.number}
            onChange={handleChange}
            placeholder="Enter number or text (e.g., 11 or 11th)"
            required
          />

          <label>Tick Marks:</label>
          <input
            type="number"
            name="tickMarks"
            value={formState.tickMarks}
            onChange={handleChange}
            placeholder="Enter number of tick marks"
            required
          />

          <label>Range From:</label>
          <input
            type="text"
            name="rangeFrom"
            value={formState.rangeFrom}
            onChange={handleChange}
            placeholder="Enter range start (e.g., 1k)"
            required
          />

          <label>Range To:</label>
          <input
            type="text"
            name="rangeTo"
            value={formState.rangeTo}
            onChange={handleChange}
            placeholder="Enter range end (e.g., 20k)"
            required
          />

          <label>Interval:</label>
          <input
            type="text"
            name="interval"
            value={formState.interval}
            onChange={handleChange}
            placeholder="Enter interval (e.g., 5k)"
            required
          />

          <button type="submit" className="submit-button">
            {isUpdateMode ? "Update Gauge" : "Create Gauge"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SalesForm;
